import { GoogleLogin, GoogleLoginResponse } from 'react-google-login'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { signInRequest } from '../../../../store/modules/auth/actions'
import { GoogleButton } from './styles'

import Google from '../../../../assets/logos/google.svg'

interface GoogleLoginProps {
  isSignOut?: boolean
  isMenu?: boolean
}

const GoogleLoginComponent: React.FC<GoogleLoginProps> = ({ isSignOut, isMenu }) => {
  const dispatch = useDispatch()

  const onSuccess = (res: GoogleLoginResponse): any => {
    return dispatch(
      signInRequest({
        email: res?.profileObj.email,
        password:
          res?.profileObj.name.replaceAll(' ', '') +
          res?.profileObj.googleId.replaceAll(' ', '') +
          res?.profileObj.email.replaceAll(' ', ''),
      })
    )
  }

  const onFailure = (res: any): any => {
    if (res.error === 'idpiframe_initialization_failed') {
      return
    }
    toast.error('Não foi possivel acessar sua conta, por favor, tente novamente.')
  }

  return (
    <GoogleLogin
      render={(renderProps) => (
        <GoogleButton onClick={renderProps.onClick} isMenu={isMenu}>
          <img src={Google} alt="Google" height="26" width="26" />
          <p>{isSignOut ? 'Cadastrar com Google' : 'Continuar com Google'}</p>
        </GoogleButton>
      )}
      clientId={`26481312030-n7s9nuci4eggtp3rqcu9clhp36ioimmf.apps.googleusercontent.com`}
      buttonText={isSignOut ? 'Cadastrar com Google' : 'Continuar com Google'}
      onSuccess={onSuccess}
      onFailure={onFailure}
      cookiePolicy={'single_host_origin'}
      isSignedIn={false}
    />
  )
}

export default GoogleLoginComponent
